import { appendToastEvent } from '@famly/mf_data-display_toast';
import { makeReducer, match } from 'web-app/util/redux';
import { generateUUID } from '@famly/vet_ts-utils_generate-uuid';
import { toToastEvent } from 'web-app/react/global-event/to-toast-event';
const initialState = { events: [] };
const createGlobalEventReducer = globalEventActions => {
    return makeReducer([
        match(globalEventActions.updateStatus, (state, { payload }) => ({
            events: appendToastEvent(state.events, toToastEvent(generateUUID(), payload)),
        })),
        match(globalEventActions.clearStatus, (state, { payload }) => ({
            events: state.events.filter(event => event.id !== payload.eventId),
        })),
    ], initialState);
};
export default createGlobalEventReducer;
